var render = function render(){
  var _vm$statusText, _vm$statusText$includ, _vm$value, _vm$value2, _vm$value2$product, _vm$value3, _vm$value4, _vm$value5, _vm$value6, _vm$value7, _vm$value7$product;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._g(_vm._b({
    attrs: {
      "tile": ""
    }
  }, 'v-card', {
    to: _vm.to
  }, false), {
    click: _vm.click
  }), [_c('div', {
    staticClass: "py-16px"
  }, [_c('v-row', {
    staticClass: "ma-n8px",
    attrs: {
      "align-md": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-8px",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": "lg"
    }
  }, [_c('v-img', _vm._b({
    attrs: {
      "width": "100",
      "height": "100"
    }
  }, 'v-img', {
    src: _vm.src
  }, false), [_c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.src,
      expression: "!src"
    }],
    attrs: {
      "absolute": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-image-broken")])], 1)], 1)], 1)], 1)], 1), _vm.mode == 'list' ? _c('v-col', {
    staticClass: "pa-8px"
  }, [_c('div', {
    staticClass: "txt txt--xs txt--light mb-4px mb-md-8px mb-lg-4px"
  }, [_c('v-row', {
    staticClass: "row--xs",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('span', {
    class: (_vm$statusText = _vm.statusText) !== null && _vm$statusText !== void 0 && (_vm$statusText$includ = _vm$statusText.includes) !== null && _vm$statusText$includ !== void 0 && _vm$statusText$includ.call(_vm$statusText, '배송완료') ? 'primary--text' : 'txt--dark'
  }, [_vm._v(_vm._s(_vm.statusText))])]), _c('v-col', {
    staticClass: "d-none d-sm-flex d-md-none d-lg-flex",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "h-12px",
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('span', [_vm._v("상품주문번호 : " + _vm._s((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.purchaseNo))])])], 1)], 1), _c('div', {
    staticClass: "txt txt--sm txt--dark font-weight-medium mb-12px"
  }, [_vm._v(_vm._s((_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : (_vm$value2$product = _vm$value2.product) === null || _vm$value2$product === void 0 ? void 0 : _vm$value2$product.name))]), _c('v-row', {
    staticClass: "row--xxs font-size-18 font-size-md-20",
    attrs: {
      "align": "center"
    }
  }, [!_vm.isTypeStout ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('strong', {
    staticClass: "d-inline-flex align-center"
  }, [_vm._v(" " + _vm._s((((_vm$value3 = _vm.value) === null || _vm$value3 === void 0 ? void 0 : _vm$value3.salePrice) * ((_vm$value4 = _vm.value) === null || _vm$value4 === void 0 ? void 0 : _vm$value4.amount)).format())), _c('small', {
    staticClass: "font-size-14 font-weight-regular pl-2px"
  }, [_vm._v("원")])])]) : _vm._e(), !_vm.isTypeStout ? _c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "txt txt--xs txt--dark"
  }, [_vm._v("·")])]) : _vm._e(), _c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "txt txt--xs txt--dark"
  }, [_vm._v(_vm._s((_vm$value5 = _vm.value) === null || _vm$value5 === void 0 ? void 0 : _vm$value5.amount) + "개")])])], 1)], 1) : _vm._e(), _vm.mode == 'view' ? _c('v-col', {
    staticClass: "pa-8px"
  }, [_c('div', {
    staticClass: "txt txt--xs txt--light mb-4px mb-md-8px"
  }, [_vm._v("상품주문번호 : " + _vm._s((_vm$value6 = _vm.value) === null || _vm$value6 === void 0 ? void 0 : _vm$value6.purchaseNo))]), _c('div', {
    staticClass: "txt txt--sm txt--dark font-weight-medium mb-12px"
  }, [_vm._v(_vm._s((_vm$value7 = _vm.value) === null || _vm$value7 === void 0 ? void 0 : (_vm$value7$product = _vm$value7.product) === null || _vm$value7$product === void 0 ? void 0 : _vm$value7$product.name))]), _c('v-row', {
    staticClass: "row--xxs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-chip', {
    attrs: {
      "x-small": "",
      "outlined": "",
      "color": "grey"
    }
  }, [_vm._v("옵션")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": ""
    }
  }, [_c('span', {
    staticClass: "txt txt--xs"
  }, [_vm._v(_vm._s(_vm.option))])])], 1)], 1) : _vm._e(), _vm.$slots['actions'] ? _c('v-col', {
    staticClass: "pa-8px",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-md-150px"
  }, [_vm._t("actions")], 2)]) : _vm._e()], 1)], 1), _vm.mode == 'list' ? _c('v-divider') : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }